import { FunnelController } from './controllers/business/FunnelController';
import { UiController } from './controllers/ui/UiController';

try {
  window.fc = FunnelController;
  window.ui = UiController;
} catch (e) {
  Errors.report(e);
}
